import axiosClient from "../../../../../../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/icover-screening-details/${id}`)

    return result.data
}
